export default {
  methods: {
    $trans(json, locale = 'lt') {
      if (typeof json === 'object') {
        const code = this.$i18n.locale ? this.$i18n.locale : locale
        return json[code]
      }
      return json
    },
    $formatPrice(priceInCents) {
      if (Number.isNaN(priceInCents)) {
        return 0
      }
      return `€ ${parseFloat(priceInCents / 100.0).toFixed(2)}`
    },
    $productTitlesMapped(productsArray) {
      if (Array.isArray(productsArray)) {
        return productsArray.map((i) => this.$trans(i.title)).join(' + ')
      }
      return ''
    }
  }
}
